const configCMS = require('./config.json');
const blogConfigCMS = require('./blogConfig.json');

module.exports = {
  // GENERAL
  siteUrl: 'https://www.boldare.com',
  pathPrefix: '/',
  siteLogo: '/assets/logo-menu.svg', // Logo used for SEO and manifest.
  // CMS
  siteTitle: configCMS.siteTitle || 'Boldare',
  siteTitleAlt: configCMS.siteTitleAlt || 'Boldare',
  siteDescription: configCMS.siteDescription || 'The digital product design & development company and your guide on the digital transformation journey.',
  siteCover: configCMS.siteCover || '',
  // BLOG
  blog: blogConfigCMS,
  // THEME
  themeColor: '#f1d624',
  backgroundColor: '#ffffff',
  // APPLICATIONS
  googleTagManagerID: 'GTM-NJN9MVR',
  disqusShortname: 'boldare',
  siteFBAppID: '',
  facebook: 'https://www.facebook.com/boldarecom/',
  linkedin: 'https://www.linkedin.com/company/boldarecom/',
  twitter: 'https://twitter.com/boldarecom',
  youtube: 'https://www.youtube.com/channel/UC44KVi7k4jlf7sQ2vn16TFw',
  instagram: 'https://www.instagram.com/boldarecom',
  awwwards: 'https://www.awwwards.com/boldare',
  clutch: 'https://clutch.co/profile/boldare',
  dribbble: 'https://dribbble.com/Boldare',
  slideshare: 'https://www.slideshare.net/Boldare',
};
